import { render } from "./ReferralSourcesManagement.vue?vue&type=template&id=0c94a2e2&scoped=true"
import script from "./ReferralSourcesManagement.vue?vue&type=script&lang=js"
export * from "./ReferralSourcesManagement.vue?vue&type=script&lang=js"

import "./ReferralSourcesManagement.vue?vue&type=style&index=0&id=0c94a2e2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c94a2e2"]])

export default __exports__